import { Curriculum, CurriculumResult } from "../../../../api/types";
import React from "react";
import { Text, View } from "@react-pdf/renderer";
import { currResultsStyle } from "./CurriculumResultsContent";
import { handleCurriculum } from "./handleCurriculum";
import { AreaAggMap, StrandAggMap, NameAggMap } from "../../../../api/types";
import { CurriculumDetails } from "./CurriculumDetails";

interface AggregatedCurriculumProps {
	data: CurriculumResult[];
}

// FYI: to avoid loooooong variable name, "Agg" means "Aggregated"
// This function aggregates curriculums in structure: Map<LearningArea, <Strand, <CurriculumName, CurriculumCode[]>>>
export const AggregatedCurriculum: React.FC<AggregatedCurriculumProps> = ({
	data,
}): JSX.Element => {
	const aggMap: AreaAggMap = handleCurriculum(data);
	return (
		<View wrap={false} style={currResultsStyle.container}>
			<Text style={currResultsStyle.title}>Curriculum</Text>
			{data === null && (
				<Text
					style={{
						fontFamily: "Inter",
						fontStyle: "normal",
						fontWeight: "semibold",
						fontSize: 16,
					}}
				>
					THERE IS NO RECORD OF CURRICULUM THAT HAS BEEN TAKEN
				</Text>
			)}
			{/* Grouped by Learning Area */}
			{data &&
				[...aggMap.keys()].map((area, i) => (
					<View key={i} wrap={false} style={currResultsStyle.areaContainer}>
						<Text style={currResultsStyle.areaName}>{area}</Text>
						{/* Grouped by Strand */}
						{[...(aggMap.get(area) as StrandAggMap).keys()].map((strand, j) => (
							<View key={j} style={currResultsStyle.strandContainer}>
								<Text style={currResultsStyle.strandName}>{strand}</Text>
								{/* Grouped by CurriculumName */}
								{[
									...(
										(aggMap.get(area) as StrandAggMap).get(strand) as NameAggMap
									).keys(),
								].map((name, k) => (
									<View key={k} style={currResultsStyle.curriculumContainer}>
										<Text style={currResultsStyle.curriculumName}>{name}</Text>
										<View style={currResultsStyle.curriculumDetailsContainer}>
											{/* Mapped CurriculumCode to individual CurriculumDetailsEntry */}
											{[
												...((
													(aggMap.get(area) as StrandAggMap).get(
														strand,
													) as NameAggMap
												).get(name) as Curriculum[]),
											].map((curr, m) => (
												<CurriculumDetails
													key={m}
													curr={curr}
													currResults={data}
												/>
											))}
										</View>
									</View>
								))}
							</View>
						))}
					</View>
				))}
		</View>
	);
};
